var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconBaocao = function SvgIconBaocao(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 22.5713H25",
    stroke: "#05060B",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29529 15.7144H5.49529V22.4953H2.29529V15.7144Z",
    stroke: "#05060B",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39038 9.69531H11.5904V22.4953H8.39038V9.69531Z",
    stroke: "#05060B",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4095 15.105H17.6095V22.4955H14.4095V15.105Z",
    stroke: "#05060B",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.505 12.2856H23.705V22.4952H20.505V12.2856Z",
    stroke: "#05060B",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89498 8.17143C2.9045 8.17143 2.06641 9.00952 2.06641 10C2.06641 10.9905 2.9045 11.8286 3.89498 11.8286C4.88545 11.8286 5.72355 10.9905 5.72355 10C5.72355 9.00952 4.96164 8.17143 3.89498 8.17143ZM9.99022 2C8.99974 2 8.16164 2.8381 8.16164 3.82857C8.16164 4.81905 8.99974 5.65714 9.99022 5.65714C10.9807 5.65714 11.8188 4.81905 11.8188 3.82857C11.8188 2.8381 10.9807 2 9.99022 2ZM16.0093 7.48571C15.0188 7.48571 14.1807 8.32381 14.1807 9.31429C14.1807 10.3048 15.0188 11.1429 16.0093 11.1429C16.9997 11.1429 17.8378 10.3048 17.8378 9.31429C17.8378 8.32381 16.9997 7.48571 16.0093 7.48571ZM22.1045 4.66667C21.114 4.66667 20.2759 5.50476 20.2759 6.49524C20.2759 7.48571 21.114 8.32381 22.1045 8.32381C23.095 8.32381 23.9331 7.48571 23.9331 6.49524C23.9331 5.50476 23.095 4.66667 22.1045 4.66667Z",
    stroke: "#2F8BFF",
    strokeMiterlimit: 22.9256
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57153 8.32393L8.39058 5.50488",
    stroke: "#2F8BFF",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5905 5.35254L14.4857 8.01921",
    stroke: "#2F8BFF",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8381 8.55251L19.9715 7.48584",
    stroke: "#2F8BFF",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBaocao, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-baocao.d16dd032.svg";
export { ForwardRef as ReactComponent };